export default "__VITE_ASSET__lcnajDvB__"